// extracted by mini-css-extract-plugin
export default {"nav":"BottomNav_nav__7sUEm","tab":"BottomNav_tab__dILtn","label":"BottomNav_label__WokrC","active":"BottomNav_active__4l86U"};